module.exports = __webpack_public_path__ + "static/expenseReport1-11b33cd9073f80f092eb876a8dd1de71.png";